import {HttpParams} from '@angular/common/http';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BaseComponent, BaseEntityModel, Term} from 'compob2b-libs';
import {Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, switchMap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    standalone: false
})
export class TermsComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() model: BaseEntityModel;
  @Output() removeTermEvent = new EventEmitter<Term>();
  @Output() insertTermEvent = new EventEmitter<Term>();

  inputFormControl: UntypedFormControl;
  terms$: Observable<Term[]>;
  termsExists = false;

  ngOnInit(): void {
    this.inputFormControl = new UntypedFormControl();
    this.terms$ = this.inputFormControl.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        filter(term => term !== null),
        map((term: string) => term.length < 2 ? null : term),
        switchMap((term: string) => this.searchTerms(term)),
      );
  }

  ngOnChanges() {
    if (this.model?.terms) {
      this.termsExists = true;
    }
  }

  searchTerms(term: string): Observable<Term[]> {
    const url = '/term/search';
    if (null === term) {
      return of([]);
    }
    term = term.toLowerCase();
    const params = new HttpParams().set('header', term);

    return this.compoApiService.getWithParams<Term[]>(url, params).pipe(
      map(response => {
        const data = response.data;
        if (data.findIndex(item => item.header === term) === -1) {
          data.unshift({id: 0, header: term});
        }
        return data;
      })
    );
  }

  insertTerm(term: Term) {
    if (term) {
      this.insertTermEvent.emit(term);
      this.inputFormControl.setValue('');
    }
  }

  removeTerm(term: Term) {
    this.confirm(translations.confirmDelete + ' ' + translations.relationship + '?', new Observable(() => {
      this.removeTermEvent.emit(term);
    }));
  }

  viewHandle(value: string) {
    return typeof value === 'string' ? value.toLowerCase() : value;
  }
}
